<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <content-area :items="shortUneditableItems" />
        <!-- HSM_OBJ_PVALUE -->
        <v-text-field
          label="HSM_OBJ_PVALUE"
          v-model="HSM_OBJ_PVALUE_value"
          counter
          readonly
        />

        <!-- Botão "Verificar checksum" -->
        <v-btn
          v-if="isBlob"
          color="blue"
          dark
          @click="openChecksumDialog"
        >
          {{ $tc('verify_checksum') }}
        </v-btn>

        <!-- HSM_ASSOCIATE -->
        <v-text-field
          label="HSM_ASSOCIATE"
          v-model="HSM_ASSOCIATE_value"
          counter
          :error-messages="HSM_ASSOCIATE_valueErrors"
          @input="$v.HSM_ASSOCIATE_value.$touch()"
          @blur="$v.HSM_ASSOCIATE_value.$touch()"
        />
      </v-col>
    </v-row>

    <!-- Componente do diálogo "Verificar checksum" -->
    <checksum-dialog :dialog-visible="checksumDialog" :p-value="HSM_OBJ_PVALUE_value" @close-dialog="closeChecksumDialog" />
  </div>
</template>

<script>
import ContentArea from '@/components/ContentArea.vue'
import { maxLength } from 'vuelidate/lib/validators'
import ChecksumDialog from './Modal/ChecksumDialog.vue'

const ALG_OBJ_BLOB = 12
const ALG_OBJ_BLOB_X509 = 13
const ALG_OBJ_BLOB_PKCS7 = 14
const ALG_OBJ_BLOB_CRL = 15

export default {
  components: {
    ContentArea,
    ChecksumDialog
  },
  props: {
    ponze: {
      type: Object,
      required: false,
      default: () => null
    },
    info: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      checksumDialog: false
    }
  },
  computed: {
    HSM_ASSOCIATE_value: {
      get () {
        return this.$store.state.keys.HSM_ASSOCIATE
      },
      set (val) {
        this.$store.commit('keys/SET_HSM_ASSOCIATE', val)
      }
    },
    HSM_OBJ_PVALUE_value () {
      return this.$store.state.keys.HSM_OBJ_PVALUE
    },
    // ERRORS
    HSM_ASSOCIATE_valueErrors () {
      const errors = []
      if (!this.$v.HSM_ASSOCIATE_value.$dirty) return errors
      !this.$v.HSM_ASSOCIATE_value.maxLength &&
        errors.push(
          this.$t('$validation.max_length', {
            num: this.$v.HSM_ASSOCIATE_value.$params.maxLength.max
          })
        )
      return errors
    },
    inputPolicy () {
      return this.$store.state.secPolicy
    },
    shortUneditableItems () {
      const uneditableKeys = ['HSM_OBJ_VERSION', 'HSM_OBJ_TYPE', 'HSM_OBJ_ATTR', 'HSM_OBJ_LEN', 'HSM_OBJ_ID']
      const myItems = []
      for (const key of uneditableKeys) {
        if (this.ponze && this.ponze[key]) {
          myItems.push(
            {
              title: key,
              data: this.ponze[key]
            }
          )
        }
      }
      return myItems
    },
    longEditableItems () {
      const longUneditableKeys = ['HSM_OBJ_PVALUE']
      const myItems = {}
      for (const key of longUneditableKeys) {
        if (this.ponze && this.ponze[key]) {
          myItems[key] = this.ponze[key]
        }
      }
      return myItems
    },
    isBlob () {
      const type = this.info.type

      switch (type) {
        case ALG_OBJ_BLOB:
        case ALG_OBJ_BLOB_CRL:
        case ALG_OBJ_BLOB_PKCS7:
        case ALG_OBJ_BLOB_X509:
          return true

        default:
          return false
      }
    }
  },
  methods: {
    openChecksumDialog () {
      this.checksumDialog = true
    },
    closeChecksumDialog () {
      this.checksumDialog = false
    }
  },
  validations () {
    return {
      HSM_ASSOCIATE_value: {
        maxLength: maxLength(this.inputPolicy.max_length_string)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  background-color: transparent;
}
</style>
